import { MapPanelDetailsPanel } from "./map-panel-details-panel/index";
import { MapPanelRoot } from "./map-panel-root";
import { MapPanelSideMenu } from "./map-panel-side-menu";
import { MapPanelTabs } from "./map-panel-tabs";

export const MapPanel = Object.assign(MapPanelRoot, {
  Tabs: MapPanelTabs,
  SideMenu: MapPanelSideMenu,
  DetailsPanel: MapPanelDetailsPanel,
});
